<cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" [expanded]="false" [class.cursor-default]="isOpenDental()">
  <div (click)="!isOpenDental() ? accordionItem.toggle() : null" class="px-6 pt-5">
    <div class="mb-4 flex items-center gap-2">
      <div class="w-fit">
        @if (patientAvatar()) {
          <lib-avatars [persons]="[patientAvatar()]" [size]="44" [fontSize]="16" />
        }
        <!-- TODO: The avatar image upload is not part of this scope, later feature -->
        <!-- <button class="btn-text mx-auto w-fit font-normal text-text-primary">
        {{ 'health_history_profile_details_edit_button_label' | translate }}
      </button> -->
      </div>
      <div class="flex flex-1 items-center justify-between">
        @if (patient()) {
          <div class="flex flex-col items-start justify-center gap-1">
            <h2 class="typo-h3-semibold">{{ patient()! | fullName }}</h2>
            <h5 class="typo-h6-light text-text-secondary">
              {{ patient()?.birthDate ?? '' | date }}
              {{ 'health_history_patient_age' | translate: { input1: (patient()?.birthDate ?? '' | age) } }}
            </h5>
          </div>
        }
        @if (!isOpenDental()) {
          <svg-icon class="text-primary-blue" [key]="accordionItem.expanded ? 'px-24-arrow-up' : 'px-24-arrow-down'"></svg-icon>
        }
      </div>
    </div>

    <div class="flex w-full justify-between gap-6">
      <lib-health-history-patient-details-item
        [icon]="'px-24-phone'"
        [displayText]="patient()?.mobilePhone ?? '-'"
      ></lib-health-history-patient-details-item>
      <lib-health-history-patient-details-item
        [icon]="'px-24-home'"
        [displayText]="patient()?.homePhone ?? '-'"
      ></lib-health-history-patient-details-item>
    </div>
  </div>
  <div [@slideToggle]="accordionItem.expanded ? 'expanded' : 'collapsed'" class="overflow-hidden px-6 pb-6">
    <div class="my-4 min-h-[1px] min-w-full bg-background-disabled"></div>
    @if (!isOpenDental()) {
      <lib-health-history-patient-secondary-contacts />
    }
  </div>
</cdk-accordion-item>
